if (!customElements.get('collection-seo-description')) {
  class CollectionSeoDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.acdc-collection-seo-desc__clamped');
      this.toggle = this.querySelector('.acdc-collection-seo-desc__toggle');
      this.toggleText = this.querySelector('.acdc-collection-seo-desc__toggle-text');
      if (!this.content || !this.toggle) return;

      this.checkOverflow();
      this.toggle.addEventListener('click', () => this.handleToggle());
    }

    checkOverflow() {
      const isOverflowing = this.content.scrollHeight > this.content.clientHeight;
      this.toggle.classList.toggle('hidden', !isOverflowing);
    }

    handleToggle() {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.content.classList.toggle('is-expanded', !expanded);
      this.toggle.setAttribute('aria-expanded', String(!expanded));
      this.toggleText.textContent = expanded ? 'Show More' : 'Show Less';
    }
  }
  customElements.define('collection-seo-description', CollectionSeoDescription);
}
